import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const skillMaps = api(async function skillMaps({ skip, take, search, sort, descending, status }) {
    return query(
        gql`
            query GetSkillMaps(
                $skip: Int
                $take: Int
                $search: String
                $sort: SkillMapSort
                $descending: Boolean
                $status: String
            ) {
                skillMaps(
                    skip: $skip
                    take: $take
                    search: $search
                    sort: $sort
                    descending: $descending
                    status: $status
                ) {
                    totalCount
                    items {
                        id
                        name
                        description
                        trades
                        isArchived
                        created
                        modified
                    }
                }
            }
        `,
        { skip, take, search, sort, descending, status },
        { returns: "skillMaps" }
    )
})
